import React, { Component } from 'react';
import Immutable from "immutable";

class TopTags extends Component {
	 constructor(props){
		  super(props);
		  this.state = {
		  }
	}

	getUTMSource(theme){
		if (theme == 'she.com') {
			return 'shecom'
		} else if (theme == 'facelift.she.com') {
			return 'facelift'
		}else if (theme == 'shemom.com'){
			return 'shemom'
		} else if (theme == 'brides.she.com') {
			return 'shebrides'
		} else if (theme == 'luxshery.com') {
			return 'luxshery'
		} else if (theme == 'k.she.com') {
			return 'kchannel'
		} else {
			return theme
		}
	}
	getUTMCampaign(page, position){
		if (page == 'home' || page == 'homepage'){
			return 'home-'+position;
		} else if (page == 'category' || page == 'channels'){
			return 'channel-'+position;
		} else if (page == 'single'){
			return 'article';
		} else {
			return page;
		}
	}

	render(){
		// const { tags } = this.state;
		const {theme, page, catName, position, tagList} = this.props;
		const utm_campaign = this.getUTMCampaign(page, position);
		const utm_term = catName? ('&utm_term='+catName) : '';
		const utmString = '?utm_source=' + this.getUTMSource(theme) + '&utm_medium=tagcloud&utm_campaign=' + utm_campaign + utm_term + '&utm_content=';

		return (
			<div>
			{
				tagList && tagList.length?
				<div className="popular-tags">
					<div className="title">trending#</div>
					<div className="tags-container">
					{
						tagList.map(function(item, index) {
							return (
								<a key={index} href={'/tag/' + item.slug + utmString + item.name} style={{background: item.color}}>{item.name}</a>
							)
						})
					}
					</div>
				</div> : ''
			}
			</div>
		)
	}
}

export default TopTags


// WEBPACK FOOTER //
// ./src/TopTags.js